import React, { FC } from 'react';
import styles from './ShareBtns.module.scss';
import cx from 'classnames';
import { Link } from 'src/components/Inputs';
import FacebookIcon from 'src/components/SVGs/Blog/FacebookIcon';
import TwitterIcon from 'src/components/SVGs/Blog/TwitterIcon';
import LinkedinIcon from 'src/components/SVGs/Blog/LinkedinIcon';

interface Props {
  title: string;
  location: string;
  showTitle?: boolean;
  className?: string;
  variant?: 'default' | 'inline';
}

const ShareBtns: FC<Props> = ({
  title,
  location,
  showTitle = true,
  className,
  variant = 'default',
}) => {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${location}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURI(
    title,
  )}%20${encodeURI(location)}`;
  const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(
    location,
  )}&title=${encodeURI(title)}`;

  return (
    <div
      className={cx(
        styles.shareBtns,
        variant === 'inline' && styles.inline,
        className,
      )}
    >
      {showTitle && <p className={styles.shareBtnsTitle}>SHARE</p>}
      <Link href={linkedInShareUrl}>
        <a
          className={styles.shareBtn}
          target='_blank'
          rel='noreferrer'
          aria-label='Share on LinkedIn'
        >
          <LinkedinIcon />
        </a>
      </Link>
      <Link href={twitterShareUrl}>
        <a
          className={styles.shareBtn}
          target='_blank'
          rel='noreferrer'
          aria-label='Share on X (Twitter)'
        >
          <TwitterIcon />
        </a>
      </Link>
      <Link href={facebookShareUrl}>
        <a
          className={styles.shareBtn}
          target='_blank'
          rel='noreferrer'
          aria-label='Share on Facebook'
        >
          <FacebookIcon />
        </a>
      </Link>
    </div>
  );
};

export default ShareBtns;
